module.exports = __webpack_public_path__ + "img/lg_ring_0_0_0_0@3x.a3ddbcef.png";